import React, { Component } from 'react';
import { connect } from 'react-redux';
import config from './../../../config';
import { shareDreamTeamOnFacebook, shareDreamTeamOnTwitter, shareTeamOfTheSeasonOnFacebook,
  shareTeamOfTheSeasonOnTwitter,} from './../../../share';

class DreamTeam extends Component {
    render() {
        const { showDC, data, gcStats, trans, constraints } = this.props;
        if (data.ShowOverallDreamTeam === 1) {
          const defaultDreamTeamUrl = "https://gaming.uefa.com/en/uclfantasy/static/dreamteam/round{{name}}.html?v=15";
          // const DreamTeamUrl = (constraints.DreamTeamUrl || defaultDreamTeamUrl).replace('{{name}}', PtGameday);
          const DreamTeamUrl = 'https://gaming.uefa.com/' + config.CURRENT_LANGUAGE + '/uclfantasy/'
          const DreamTeamTrans = {
            "fb_dreamteam_share_caption": trans.teamOfTheSeasonShareCaption || '',
            "fb_dreamteam_share_description":
              trans.teamOfTheSeasonShareDesc || 'Check out who made it to Team of the Season for Champions League',
          };
          let DTImg = config.DTImgUrl.replace(
            '{{PtGameday}}',
            config.teamOftheSeasonRoundNumber
          ); //FOR TEAM OF THE SEASON :100
          
          let DTDefaultImg = config.DTDefaultImgUrl;
          return showDC ? <div className="si-card si-team-card">
              <div className="si-pitch-view-wrap"
                  style={ { backgroundImage: "url(" + DTImg + ")" } } />
              { DreamTeamUrl ? <div className="si-social-card">
                  <div className="si-social-share">
                      <div className="si-title">{ trans['share'] }:</div>
                      <div className="si-share-med">
                          <div className="si-share-item si-fb-share">
                              <i className="icon-ucl-facebook"
                                  onClick={ (e) => shareTeamOfTheSeasonOnFacebook(e, DreamTeamUrl, DreamTeamTrans) } />
                          </div>
                          <div className="si-share-item si-tweet-share">
                              <i className="icon-ucl-twitter"
                                  onClick={ (e) => shareTeamOfTheSeasonOnTwitter(e, DreamTeamUrl, DreamTeamTrans) } />
                          </div>
                      </div>
                  </div>
              </div> : null }
          </div>
              : null
          
        } else {
          const { PtGameday } = gcStats;
          const defaultDreamTeamUrl = "https://gaming.uefa.com/en/uclfantasy/static/dreamteam/round{{name}}.html?v=15";
          // const DreamTeamUrl = (constraints.DreamTeamUrl || defaultDreamTeamUrl).replace('{{name}}', PtGameday);
          const DreamTeamUrl = 'https://gaming.uefa.com/' + config.CURRENT_LANGUAGE + '/uclfantasy/'
          const DreamTeamTrans = {
              "fb_dreamteam_share_caption": (trans.fb_dreamteam_share_caption || ''),
              "fb_dreamteam_share_description": (trans.fb_dreamteam_share_description || 'Share the UCL Fantasy team of the week!')
          };
          let DTImg = config.DTImgUrl.replace('{{PtGameday}}', PtGameday);
  
          let DTDefaultImg = config.DTDefaultImgUrl;
          return showDC ? <div className="si-card si-team-card">
              <div className="si-pitch-view-wrap"
                  style={ { backgroundImage: "url(" + DTImg + ")" } } />
              { DreamTeamUrl ? <div className="si-social-card">
                  <div className="si-social-share">
                      <div className="si-title">{ trans['share'] }:</div>
                      <div className="si-share-med">
                          <div className="si-share-item si-fb-share">
                              <i className="icon-ucl-facebook"
                                  onClick={ (e) => shareDreamTeamOnFacebook(e, DreamTeamUrl, DreamTeamTrans) } />
                          </div>
                          <div className="si-share-item si-tweet-share">
                              <i className="icon-ucl-twitter"
                                  onClick={ (e) => shareDreamTeamOnTwitter(e, DreamTeamUrl, DreamTeamTrans) } />
                          </div>
                      </div>
                  </div>
              </div> : null }
          </div>
              : null
        }
    }
}

const mapSateToProps = (state) => {
    return {
        constraints: state.appData.constraints,
        trans: state.appData.trans,
    };
};
export default (connect(mapSateToProps, null)(DreamTeam));


// WEBPACK FOOTER //
// ./src/components/home/cards/DreamTeam.js